import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../common/ThemeContext";
import { useSeason } from "../../../common/SeasonContext";
import { usePlayersPerf } from "../../../common/PlayersPerfContext";
import WeeklyRecapTab from "./WeeklyRecapTab.jsx";

export default function WeeklyRecapReport({ isDev = false }) {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const { season } = useSeason();
  const {
    players,
    loading,
    error,
    clubInfo,
  } = usePlayersPerf();

  return (
    <div className={`${isDarkMode ? "bg-gray-900 text-gray-100" : "bg-gray-100 text-gray-900"} min-h-screen p-6`}>
      <div className="mx-auto max-w-[1680px] space-y-4">
        {loading ? (
          <div className={`rounded-2xl ring-1 px-4 py-10 text-center text-sm ${isDarkMode ? "bg-gray-800/70 ring-white/10 text-gray-400" : "bg-white ring-black/10 text-gray-500"}`}>
            {t("common.loading", { defaultValue: "Loading..." })}
          </div>
        ) : error ? (
          <div className={`rounded-2xl ring-1 px-4 py-10 text-center text-sm ${isDarkMode ? "bg-gray-800/70 ring-white/10 text-rose-300" : "bg-white ring-black/10 text-rose-600"}`}>
            {error?.message || t("weekly_recap.errors.load", { defaultValue: "Unable to load weekly recap" })}
          </div>
        ) : (
          <WeeklyRecapTab
            players={players}
            season={season}
            clubId={clubInfo?.id}
            isDarkMode={isDarkMode}
            isDev={isDev}
          />
        )}
      </div>
    </div>
  );
}
